import { render, staticRenderFns } from "./iam-view-page.vue?vue&type=template&id=b8a3f880&"
import script from "./iam-view-page.vue?vue&type=script&lang=js&"
export * from "./iam-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports